<template>
  <div>
    <div
      v-show="hasRequirement"
      v-scroll="{el: 'page', scrollOn: scroll.scrollOn, speed: scroll.speed}"
      class="section section-secondary section--border"
    >
      <div class="container container-padding">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div class="block block-default text-black mb-4">
              <strong class="d-block mb-3">{{ regulation.requirement.title }}</strong>
              <div v-dompurify-html="regulation.requirement.body" />
            </div>
            <a
              v-show="hasRequirementLink"
              :href="regulation.requirement.link"
              @click.prevent="onRequirementClick()"
            >
              {{ regulation.requirement.link_text }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="hasFollowUp"
      class="section section-tertiary section--border mt-0"
    >
      <div class="container container-padding">
        <div class="row">
          <div class="col-md-6 offset-md-3 text-center">
            <follow-up-steps
              v-show="isFollowUpSteps"
              :data="regulation.followup"
            />
            <follow-up-instruction
              v-show="isFollowUpInstruction"
              :data="regulation.followup"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import FollowUpSteps from 'app/components/follow-up/steps'
import FollowUpInstruction from 'app/components/follow-up/instruction'

import datalayer from 'app/mixin/datalayer'

export default {
  name: 'ResultDetailDefault',
  components: {
    FollowUpSteps,
    FollowUpInstruction
  },
  mixins: [datalayer],
  data () {
    return {
      scroll: {
        scrollOn: 'init',
        speed: 600
      }
    }
  },
  computed: {
    ...mapState([
      'loading',
      'regulation'
    ]),
    hasRequirement () {
      return (typeof this.regulation.requirement !== 'undefined')
    },
    hasRequirementLink () {
      const link = this.regulation.requirement.link
      return (link && typeof link !== 'undefined')
    },
    hasFollowUp () {
      return (typeof this.regulation.followup !== 'undefined')
    },
    isFollowUpSteps () {
      const followUp = this.regulation.followup
      return (typeof followUp.steps === 'object')
    },
    isFollowUpInstruction () {
      const followUp = this.regulation.followup
      return (typeof followUp.steps !== 'object')
    }
  },
  methods: {
    onRequirementClick () {
      const link = this.regulation.requirement.link || ''
      const labelValue = link.replace(/^https?:\/\//i, '')

      this.gtmTrackEvent({
        category: 'Button',
        action: 'Click',
        label: `Link to ${labelValue}`,
        eventCallback: function () {
          window.open(link, '_blank')
        }
      })
    }
  }
}
</script>
